/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Plain Text Import" |
*
* @param {Plain_Text_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_title = /** @type {((inputs?: Plain_Text_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation de texte brut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import von Klartext")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione di testo normale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт простого текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de texto sin formato")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("纯文本导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレーンテキストインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("साधारण पाठ आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de texto simples")
	return /** @type {LocalizedString} */ ("Plain Text Import")
});